import { render } from "./PrivacyPolicy_android.vue?vue&type=template&id=6768d31d&scoped=true"
import script from "./PrivacyPolicy_android.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy_android.vue?vue&type=script&lang=js"

import "./PrivacyPolicy_android.vue?vue&type=style&index=0&id=6768d31d&scoped=true&lang=less"

import exportComponent from "/opt/apps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6768d31d"]])

export default __exports__